export default function () {
    $(document).on("click", ".clone-add", function () {
        var uniqueId = new Date().getTime();

        $(this).siblings(".clonable").eq(0).clone().insertBefore($(this))
            .find("input.single-package-weight").each(function () {
                var attrName = $(this).attr("name");

                $(this).attr("name", attrName + uniqueId);
            });
    });

    $(document).on("click", ".clone-remove", function () {
        if ($(this).closest(".package-container").find(".clonable").length > 1)
            $(this).closest(".clonable").remove();
        else {
            alert("Musi istnieć conajmniej jedna przesyłka");
        }
    });
}